import type {
  ServiceGetAllResponse,
  ServiceGetByIdResponse,
  ServiceMutationOptionType,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { FilterSubitemKepValues } from '../validation'
import type { KemitraanUsahaDataType } from './types'
import type { MutationKemitraanUsahaValues } from './validation'

const QUERY_KEY = (key?: string | Record<string, any>) =>
  ['kep-kemitraan-usaha', key] as const

const getAll = (
  params?: FilterSubitemKepValues
): ServiceQueryOptionType<
  ServiceGetAllResponse<Array<KemitraanUsahaDataType>>
> => ({
  queryKey: QUERY_KEY(params),
  queryFn: async () => {
    try {
      const response = await api.get<
        ServiceGetAllResponse<Array<KemitraanUsahaDataType>>
      >(`/kelembagaan/kep/${params?.id_kep}/kemitraan-usaha`, {
        params: {
          ...params,
          id_kep: undefined
        }
      })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const create = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<KemitraanUsahaDataType>,
  MutationKemitraanUsahaValues
> => ({
  mutationFn: async (data: MutationKemitraanUsahaValues) => {
    try {
      const response = await api.post<
        ServiceGetByIdResponse<KemitraanUsahaDataType>
      >(`/kelembagaan/kep/${data?.id_kep}/kemitraan-usaha`, {
        ...data,
        id_kemitraan_usaha: data?.id_kemitraan_usaha?.value,
        kep_bentuk_mitra: data?.kep_bentuk_mitra?.map(item => item.value)
      })
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const update = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<KemitraanUsahaDataType>,
  MutationKemitraanUsahaValues
> => ({
  mutationFn: async (data: MutationKemitraanUsahaValues) => {
    try {
      const response = await api.put<
        ServiceGetByIdResponse<KemitraanUsahaDataType>
      >(
        `/kelembagaan/kep/${data?.id_kep}/kemitraan-usaha/${data.id_default_kemitraan_usaha}`,
        {
          ...data,
          id_kemitraan_usaha: data?.id_kemitraan_usaha?.value,
          kep_bentuk_mitra: data?.kep_bentuk_mitra?.map(item => item.value)
        }
      )
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

const deleteData = (): ServiceMutationOptionType<
  ServiceGetByIdResponse<KemitraanUsahaDataType>,
  { id_kep: string; id_data: string }
> => ({
  mutationFn: async (data: { id_kep: string; id_data: string }) => {
    try {
      const response = await api.delete<
        ServiceGetByIdResponse<KemitraanUsahaDataType>
      >(`/kelembagaan/kep/${data?.id_kep}/kemitraan-usaha/${data?.id_data}`)
      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const kemitraanUsaha = {
  queryKey: [QUERY_KEY(undefined)[0]],
  getAll,
  create,
  update,
  deleteData
}
